class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.submitButton = this.querySelector("[name='checkout']");
    if (this.submitButton) this.submitButton.addEventListener('click', this.onSubmit.bind(this));
  }

  onSubmit() {
    const analyticsData = this.querySelector("script[type='application/json']");
    if (analyticsData) {
      let ecommerce = analyticsData.textContent;
      ecommerce = JSON.parse(ecommerce);
      dataLayer.push({
        pageType: 'Cart Notification',
        event: 'begin_checkout',
        ecommerce
      });
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
  }

  /*
    Dev servers don't always return the section in the cart response
    If they're not returned we manually fetch them
    See: https://github.com/Shopify/shopify-cli/issues/1797#issuecomment-1153484659
  */
  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key ? parsedState.key : parsedState.items[0].key;
    // Discounts being auto-applied break the sync between the sections response and the cart response
    // The fallback key here attempts to match to a product in our response based on the most unique key we can make
    // This might not work 100% in all scenarios but I believe this should cover any native-ish dawn conditions
    this.fallbackKey = `${parsedState.id}-${parsedState.variant_id}-${parsedState.quantity}`;
    // Fetch missing sections in development environments
    if (!parsedState.sections) {
      const sections = await fetch(
        `${routes.cart_url}?sections=${this.getSectionsToRender().map((section) => section.id)}`
      );
      parsedState.sections = await sections.json();
    }
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
        this.fallbackKey
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', fallbackSelector) {
    const markup = new DOMParser().parseFromString(html, 'text/html');
    let returnMarkup = markup.querySelector(selector);
    if (!returnMarkup)
      returnMarkup = markup.querySelector(`[data-fallback-key='${fallbackSelector}']`);
    if (returnMarkup) return returnMarkup.innerHTML;
    return null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
